module.exports = __webpack_public_path__ + "img/home5.21f28856.jpg";